<canvas #compassCanvas></canvas>
